<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('service.c1.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('service.c1.t1.title')"
        :textArray="[$t('service.c1.t1.p0'), $t('service.c1.t1.p1')]"
        :noteText="$t('service.c1.t1.note')"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('service.c1.t2.title')"
        :textArray="[]"
        :downloadText="$t('service.c1.t2.download')"
        downloadFileName="Hans-Lebrecht-Schule_SD.pdf"
      >
        <ul
          slot="content"
        >
          <li>{{ $t('service.c1.t2.li0') }}</li>
          <li>{{ $t('service.c1.t2.li1') }}</li>
          <li>{{ $t('service.c1.t2.li2') }}</li>
          <li>{{ $t('service.c1.t2.li3') }}</li>
          <li>{{ $t('service.c1.t2.li4') }}</li>
          <li>{{ $t('service.c1.t2.li5') }}</li>
          <li>{{ $t('service.c1.t2.li6') }}</li>
        </ul>
      </ContentTile>
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('service.c2.title')"
      :subtitle="$t('service.c2.subtitle')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('service.c2.t1.title')"
        :textArray="[$t('service.c2.t1.p0'), $t('service.c2.t1.p1'), $t('service.c2.t1.p2'), $t('service.c2.t1.p3')]"
        :downloadText="$t('service.c2.t1.download')"
        downloadFileName="Hans-Lebrecht-Schule_Widsn.pdf"
      />
      <ContentImageTile
        embedded
        imageSource="/img/projekte/was_ist_schon_normal/cover.jpg"
      />
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('service.c3.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="null"
        :textArray="[]"
        :downloadText="$t('service.c3.d0')"
        downloadFileName="Hans-Lebrecht-Schule_Unterricht.pdf"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="null"
        :textArray="[]"
        :downloadText="$t('service.c3.d1')"
        downloadFileName="Hans-Lebrecht-Schule_Prinzipien.pdf"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="null"
        :textArray="[]"
        :downloadText="$t('service.c3.d2')"
        downloadFileName="Hans-Lebrecht-Schule_FAQ.pdf"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="null"
        :textArray="[]"
        :downloadText="$t('service.c3.d3')"
        downloadFileName="Hans-Lebrecht-Schule_Corona.pdf"
      />
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('tservice.c4.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('tservice.c4.t1.title')"
        :textArray="[$t('tservice.c4.t1.p0'), $t('tservice.c4.t1.p1'), $t('tservice.c4.t1.p2'), $t('tservice.c4.t1.p3')]"
      >
        <v-row
          slot="content"
        >
          <v-col
            cols="12"
            align="center"
          >
            <ExternalLinkButton
              :themeColor="computedTopicColor"
              href="https://www.uniklinik-ulm.de/kinder-und-jugendpsychiatriepsychotherapie/forschung-und-arbeitsgruppen/arbeitsgruppe-wissenstransfer-dissemination-e-learning.html"
              :text="$t('tservice.c4.t1.link')"
            />
          </v-col>
        </v-row>
      </ContentTile>
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('tservice.c4.t2.title')"
        :textArray="[]"
      >
        <v-row
          slot="content"
        >
          <v-col
            cols="12"
            align="center"
          >
            <ExternalLinkButton
              :themeColor="computedTopicColor"
              href="https://elearning-kinderschutz.de/"
              :text="$t('tservice.c4.t2.link')"
            />
          </v-col>
        </v-row>
      </ContentTile>
    </ContentContainer>
  </ContentFrame>
</template>

<script>
import { mapGetters } from 'vuex'

import ContentContainer from '@/views/components/ContentContainer.vue'
import ContentTile from '@/views/components/ContentTile.vue'
import ContentFrame from '@/views/components/ContentFrame.vue'
import ContentImageTile from '@/views/components/ContentImageTile.vue'
import ExternalLinkButton from '@/views/components/ExternalLinkButton.vue'

export default {
  name: 'TService',
  components: {
    ContentTile,
    ContentContainer,
    ContentFrame,
    ContentImageTile,
    ExternalLinkButton
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    computedTopicColor () {
      return this.menuData.tService.color
    },
    computedTitle () {
      return this.menuData.tService.title
    }
  }
}
</script>

<style scoped>
</style>
